// extracted by mini-css-extract-plugin
export default {"pdf_container":"pdf__pdf_container__LODgJ","pdfContainer":"pdf__pdf_container__LODgJ"};